import Q from "q";
import _ from "underscore";
import get_emun_selector_List from "./lib/get_emun_selector_List";
import moment from "moment";

const cache_list = [];//已请求过单选下拉框list的数据信息

export default {
    props: {
        enableAutoInit: {
            type: Boolean,
            required: false,
            default: false,
        },
        value: {
            default: ''
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        clearable: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data() {
        return {
            options: [],//下拉框里的选项list
            init_parameter: {
                type: '000',//1.'000'-通过页面传入的request_url获取entity_list；2.'100'-页面直接传入entity_list
                request_url: '',//用于获取entity_list的接口地址
                get_data_source: {
                    entity_list: [],//页面传入的下拉框里的数据
                },
                option_all: {//全部这个选项的相关配置
                    is_show: true,
                    text: '全部',
                    value: '',
                },
                disabled: false,//是否禁用
                clearable: false//是否可以清空选项
            },
            value_for_v_model: '',//选中的值
            isDisabled: true,//是否禁用
            isClearable: true//是否可以清空选项
        };
    },
    watch: {
        value: {
            handler(newVal) {
                this.value_for_v_model = newVal;
            },
            immediate: true
        },
        value_for_v_model(newVal) {
            this.$emit('input', newVal)
        }
    },
    methods: {
        //传入请求地址获取数据
        async __initData() {
            const request_url = this.init_parameter.request_url;
            //如果没传入请求地址则返回错误信息
            if (!request_url) {
                return Q.reject('request_url is null')
            }
            //增加“全部”这个选项
            this.options = [];
            if (this.init_parameter.option_all.is_show) {
                this.options = [{
                    value: this.init_parameter.option_all.value,
                    text: this.init_parameter.option_all.text
                }];
            }
            //查找是否已请求过该数据list
            const query = _.chain(cache_list)
                .find(function (m) {
                    return m.key === request_url;
                })
                .value();
            let res;
            if (query) {
                //有已请求过的数据记录
                res = query.promise;
            } else {
                //无已请求过的数据记录
                res = await get_emun_selector_List({
                    request_url: request_url
                });
                const cache = {};
                cache.key = request_url;
                cache.promise = res;
                cache_list.push(cache)
            }

            this.options = [...this.options, ...res.datas.result];
        },

        //传入下拉框list数据
        async __initDataFromPage() {
            //是否有“全部”选项
            this.options = [];
            if (this.init_parameter.option_all.is_show) {
                this.options = [{
                    value: this.init_parameter.option_all.value,
                    text: this.init_parameter.option_all.text
                }];
            }
            let data = await this.init_parameter.get_data_source();
            this.options = [...this.options, ...data.entity_list];
        },

        //--------------------------------------------------------------------------------------------------------------

        //初始化
        async init(init_parameter) {
            this.init_parameter = {...this.init_parameter, ...init_parameter};
            //this.init_parameter.type：
            // 1.'000'-通过页面传入的request_url获取entity_list；
            // 2.'100'-页面直接传入entity_list
            if (this.init_parameter.type === '000') {
                await this.__initData();
            } else {
                await this.__initDataFromPage();
            }

            //优先使用init方法中传入的disabled，如无传入则使用模板中传入的disabled
            if ('disabled' in init_parameter) {
                this.isDisabled = this.init_parameter.disabled;
            } else {
                this.isDisabled = this.disabled;
            }

            //优先使用init方法中传入的disabled，如无传入则使用模板中传入的disabled
            if ('clearable' in init_parameter) {
                this.isClearable = this.init_parameter.clearable;
            } else {
                this.isClearable = this.clearable;
            }
        },
    },
    mounted() {
        //是否自动init
        if (this.enableAutoInit) this.init();
    },
}
